"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = requireUser;
function requireUser(req, res, next) {
    if (!req.session.userId || !req.user?.userId) {
        res.sendStatus(401);
    }
    else {
        next();
    }
}
